import * as headerCopyExperiment from '../experiments/header-copy';
import WithExperiment from './WithExperiment';

type ExperimentLoaderProps = {
  children: React.ReactNode;
};

const ExperimentLoader = ({ children }: ExperimentLoaderProps) => (
  <>
    <WithExperiment {...headerCopyExperiment} showLoadingIndicator={false} />
    {children}
  </>
);

export default ExperimentLoader;
